import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiGridContainer' })(
  ({ breakpoints, typography }) => ({
    wrapper: {
      margin: `0 ${typography.pxToRem(24)}`,

      [breakpoints.up('sm')]: {
        margin: `0 ${typography.pxToRem(40)}`,
      },
      [breakpoints.up('md')]: {
        margin: `0 ${typography.pxToRem(64)}`,
      },
      [breakpoints.up('lg')]: {
        margin: `0 ${typography.pxToRem(80)}`,
      },
    },
    fixed: {
      [breakpoints.up('lg')]: {
        maxWidth: typography.pxToRem(1280),
        width: '100%',
        margin: '0 auto',
      },
    },
  })
);

export default useStyles;
